import React, { useState } from 'react';
import ScrollReactTable from 'components/shared/ScrollReactTable/ScrollReactTable';
import moment from 'moment';
import SvgAF, { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { defaultSWDeviceTypes } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import { reactTableSortOnClickInFuncComp } from 'common/utils/helpers';
import classnames from 'classnames';
import DropModal from 'components/shared/DropModal/DropModal';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import './SoftwareManagerTable.css';
import DeviceTypeChip from 'components/shared/DeviceTypeChip/DeviceTypeChip';

export const SoftwareManagerTable = (props) => {
  const { fetching, swVersionTableData, parent, error } = props;

  let [sorted, setSorted] = useState([{ id: 'uploaded_on', desc: true }]);

  const ellipsisButton = (
    <div className={'editEllipsis'}>
      <SvgAF img={IconLoader.icon_threeV} hover={IconLoader.icon_threeV_hover} />
    </div>
  );

  let overlay = null;
  if (error && (swVersionTableData == null || swVersionTableData.length === 0)) {
    overlay = (
      <div className="Global_Table_ErrorOverlay">
        <div className="Global_Table_Error_Div">
          <div className="Global_Table_ErrorOverlay_Title">Error </div>
          <div className="Global_Table_ErrorOverlay_Message">
            An unexpected problem occurred and this data is unavailable. Please try refreshing the page, and if the
            problem persists, contact us at
            <a href="mailto:support@pivotalcommware.com"> support@pivotalcommware.com</a>
          </div>
        </div>
      </div>
    );
  }

  const columns = (parent) => [
    {
      Header: (col) => {
        return (
          <div className="swManager_Table_Header_OuterDiv">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Version'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'sw_version')}
            />
            <div className="swManager_Table_Header_ResizerSliderIcon">
              <div className="swManager_Table_Header_ResizerSliderIcon_Bar"></div>
            </div>
          </div>
        );
      },
      id: 'sw_version',
      minWidth: 90,
      accessor: (swVersion) => {
        return { swVersion: swVersion.sw_version };
      },
      Cell: (row) => {
        let swVersion = row.value.swVersion;
        return (
          <div className="swManager_Table_cellWrapper" data-tip={swVersion}>
            <span>{swVersion}</span>
          </div>
        );
      },
      sortMethod: (a, b) => {
        return a.swVersion.toLowerCase() > b.swVersion.toLowerCase() ? 1 : -1;
      }
    },
    {
      Header: (col) => {
        return (
          <div className="swManager_Table_Header_OuterDiv">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Uploaded on'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'uploaded_on')}
            />
            <div className="swManager_Table_Header_ResizerSliderIcon">
              <div className="swManager_Table_Header_ResizerSliderIcon_Bar"></div>
            </div>
          </div>
        );
      },
      id: 'uploaded_on',
      minWidth: 110,
      accessor: (swVersion) => {
        return swVersion.uploaded_on;
      },
      Cell: (row) => {
        let uploadedOn = moment(row.value).format('MMM D, YYYY, h:mm a');
        return (
          <div className="swManager_Table_cellWrapper" data-tip={uploadedOn}>
            {uploadedOn}
          </div>
        );
      },
      sortMethod: (a, b) => {
        return a > b ? 1 : -1;
      }
    },
    {
      Header: (col) => {
        return (
          <div className="swManager_Table_Header_OuterDiv">
            <IconAndText
              img={IconLoader.icon_table_sort}
              hoverImg={IconLoader.icon_table_sort_hover}
              text={'Device types'}
              reverse
              onClick={() => reactTableSortOnClickInFuncComp(sorted, setSorted, 'device_types')}
            />
          </div>
        );
      },
      id: 'device_types',
      resizable: false,
      minWidth: 220,
      accessor: (swVersion) => {
        let supportedDeviceTypes = swVersion.supported_device_types;
        let stringForSorting = '';
        supportedDeviceTypes &&
          supportedDeviceTypes.forEach(
            (deviceType) => defaultSWDeviceTypes[deviceType] && (stringForSorting += deviceType)
          );

        return { supportedDeviceTypes, stringForSorting };
      },
      Cell: (row) => {
        let supportedDeviceTypes = row.original && row.original.supported_device_types;
        let chips = supportedDeviceTypes ? (
          supportedDeviceTypes.map((deviceType, idx) => {
            let deviceTypeObj = defaultSWDeviceTypes[deviceType];
            return deviceTypeObj ? (
              <div key={idx}>
                <DeviceTypeChip productType={deviceTypeObj.title} size={'medium'} />
              </div>
            ) : (
              <div key={idx}></div>
            );
          })
        ) : (
          <div></div>
        );

        return (
          <div
            className={classnames({
              swManager_Table_cellWrapper: true,
              swManager_Table_DeviceTypeChipsWrapper: true
            })}
          >
            <PerfectScrollbar options={{ wheelPropagation: false, suppressScrollY: true }}>{chips}</PerfectScrollbar>
          </div>
        );
      },
      sortMethod: (a, b) => {
        return a.stringForSorting > b.stringForSorting ? 1 : -1;
      }
    },
    {
      id: 'delete_sw',
      accessor: 'delete_sw',
      sortable: false,
      maxWidth: 40,
      resizable: false,
      Cell: (row) => {
        let swid = row.original.sw_identifier;
        return (
          <div className="swManager_Table_ActionCell_OuterDiv swManager_Table_ActionCell_EllipsisBtn">
            {parent.state.deleteSWPermissions ? (
              <SvgAF
                img={IconLoader.icon_delete_button_default}
                hover={IconLoader.icon_delete_button_hover}
                tooltip={'Delete this version'}
                onClick={() => {
                  if (swid != null) {
                    parent.setState({
                      deleteSwModalOpen: true,
                      deleteSwVersionId: swid,
                      deleteSwFailed: false,
                      deleteSwPending: false
                    });
                    //parent.props.dispatch(deleteSoftwareVersion(swid));
                  }
                }}
              />
            ) : (
              <SvgAF img={IconLoader.icon_delete_button_disabled} tooltip={'No permission to delete versions'} />
            )}
          </div>
        );
      }
    }
  ];

  return (
    <ScrollReactTable
      className="Global_Table AdminPage_swManager_Table"
      showPagination={false}
      minRows={13}
      fetching={fetching}
      overlay={overlay}
      noDataText={''}
      pageSize={swVersionTableData.length}
      data={swVersionTableData}
      columns={columns(parent)}
      sorted={sorted}
      onSortedChange={(newSorted, column, shiftKey) => {
        setSorted(newSorted);
      }}
    />
  );
};
